import axios from "axios";
import qs from "qs";
import { stripeConfig as Config, STRIPE_API_BASE } from "../api";

export default store => {
  return {
    $store: store,
    getSession(sessionId) {
      return axios(
        Object.assign(Config(store), {
          method: "get",
          url: STRIPE_API_BASE + `/checkout/sessions/${sessionId}`
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    getPaymentIntent(paymentIntentId) {
      return axios(
        Object.assign(Config(store), {
          method: "get",
          url: STRIPE_API_BASE + `/payment_intents/${paymentIntentId}`
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    createPaymentIntent(data) {
      return axios
        .post(
          STRIPE_API_BASE + `/payment_intents`,
          qs.stringify(data),
          Config(store)
        )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },

    createSession(data) {
      return axios
        .post(
          STRIPE_API_BASE + `/checkout/sessions`,
          qs.stringify(data),
          Config(store)
        )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    getPaymentMethod(paymentMethodId) {
      return axios(
        Object.assign(Config(store), {
          method: "get",
          url: STRIPE_API_BASE + `/payment_methods/${paymentMethodId}`
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    getCustomer(customerId) {
      return axios(
        Object.assign(Config(store), {
          method: "get",
          url: STRIPE_API_BASE + `/customers/${customerId}`
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    attachPaymentMethod(paymentMethodId, data) {
      return axios
        .post(
          STRIPE_API_BASE + `/payment_methods/${paymentMethodId}/attach`,
          qs.stringify(data),
          Config(store)
        )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    chargeCustomer(data) {
      return axios
        .post(
          STRIPE_API_BASE + `/payment_intents`,
          qs.stringify(data),
          Config(store)
        )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    createCharge(data) {
      return axios
        .post(STRIPE_API_BASE + `/charges`, qs.stringify(data), Config(store))
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    createCustomer() {
      return axios
        .post(STRIPE_API_BASE + `/customers `, qs.stringify({}), Config(store))
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    updateCustomerSource(customerId, data) {
      return axios
        .post(
          STRIPE_API_BASE + `/customers/${customerId}`,
          qs.stringify(data),
          Config(store)
        )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    }
  };
};
